(function () {
  if (window.__rbSampleChooser) return;
  window.__rbSampleChooser = true;

  var busy = false;

  function updateUrl() { return (window.routes && window.routes.cart_update_url) || '/cart/update.js'; }
  function parse(html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); }

  function drawerTargets() {
    var targets = [];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) targets.push({ id: 'cart-icon-bubble', selector: '.shopify-section', el: bubble });
    var drawer = document.querySelector('#CartDrawer .drawer__inner');
    if (drawer) targets.push({ id: 'cart-drawer', selector: '.drawer__inner', el: drawer });
    return targets;
  }

  function updateCart(updates) {
    if (busy) return Promise.resolve();
    busy = true;
    var onCartPage = !!document.getElementById('main-cart-items');
    var targets = onCartPage ? [] : drawerTargets();
    var body = { updates: updates, sections_url: window.location.pathname };
    if (targets.length) body.sections = targets.map(function (t) { return t.id; });
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (onCartPage) { window.location.reload(); return; }
        if (!state.sections) return;
        targets.forEach(function (t) {
          var html = state.sections[t.id];
          if (!html || !t.el) return;
          var fresh = parse(html, t.selector);
          if (fresh) t.el.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.rb-sc__card');
    if (!card || busy) return;
    e.preventDefault();
    var variantId = card.getAttribute('data-variant-id');
    var isSelected = card.getAttribute('data-selected') === 'true';
    var stateEl = document.querySelector('rb-sample-state');
    var current = stateEl ? stateEl.getAttribute('data-sample-in-cart') : '';
    var updates = {};
    if (isSelected) {
      updates[variantId] = 0;
    } else if (current && current !== variantId) {
      updates[current] = 0;
      updates[variantId] = 1;
    } else {
      updates[variantId] = 1;
    }
    updateCart(updates);
  });

  function accentMap(stateEl) {
    var map = {};
    (stateEl.getAttribute('data-sample-accents') || '').split(',').filter(Boolean).forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i > 0) map[pair.slice(0, i)] = pair.slice(i + 1);
    });
    return map;
  }

  function decorateSampleRows(stateEl) {
    var map = accentMap(stateEl);
    if (!Object.keys(map).length) return;
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var vid = null;
      var input = row.querySelector('[data-quantity-variant-id]');
      if (input) vid = input.getAttribute('data-quantity-variant-id');
      if (!vid) { var rm = row.querySelector('[data-variant-id]'); if (rm) vid = rm.getAttribute('data-variant-id'); }
      if (!vid || !map[vid]) return;

      var stepper = row.querySelector('quantity-input');
      if (stepper) stepper.style.display = 'none';

      var media = row.querySelector('.cart-item__media');
      if (media && !media.querySelector('img') && !media.querySelector('.rb-cart-bag')) {
        media.innerHTML =
          '<span class="rb-cart-bag" style="display:block;width:70px;height:90px;background:#1a1a1a;border-radius:4px;position:relative;margin:0 auto;">' +
          '<span style="position:absolute;left:10px;right:10px;top:33px;height:22px;background:' + map[vid] + ';border-radius:2px;display:block;"></span></span>';
      }
    });
  }

  // One free sample, only on a qualifying order. Reads the live cart on every
  // load and fixes anything that slipped in another way: extra quantity, a
  // second sample, or a sample on a cart that no longer qualifies.
  function enforceSampleRules(stateEl) {
    if (busy) return;
    var map = accentMap(stateEl);
    if (!Object.keys(map).length) return;
    var total = parseInt(stateEl.getAttribute('data-total') || '0', 10);
    var threshold = parseInt(stateEl.getAttribute('data-threshold') || '9000', 10);
    var qualified = total >= threshold;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var samples = (cart.items || []).filter(function (it) { return map[String(it.variant_id)]; });
        if (!samples.length) return;
        var updates = {};
        if (!qualified) {
          samples.forEach(function (it) { updates[it.variant_id] = 0; });
        } else {
          var keep = samples[0].variant_id;
          samples.forEach(function (it) {
            if (it.variant_id === keep) {
              if (it.quantity !== 1) updates[it.variant_id] = 1;
            } else {
              updates[it.variant_id] = 0;
            }
          });
        }
        if (Object.keys(updates).length) updateCart(updates);
      })
      .catch(function () {});
  }

  if (!customElements.get('rb-sample-state')) {
    customElements.define('rb-sample-state', class extends HTMLElement {
      connectedCallback() {
        decorateSampleRows(this);
        enforceSampleRules(this);
      }
    });
  }
})();